import React from 'react';

export function FilterToggleButton({
  active = false,
  onClick,
  className = '',
  ariaLabel = 'Toggle filters',
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center justify-center gap-1.5 rounded-lg border px-3 py-2 text-sm font-medium shadow-sm ${
        active
          ? 'border-brand bg-brand/5 text-brand'
          : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-50'
      } ${className}`}
      aria-label={ariaLabel}
      aria-pressed={active}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
      </svg>
      Filter
      {active ? (
        <span className="rounded-full bg-brand px-1.5 text-[10px] font-semibold text-white">
          ON
        </span>
      ) : null}
    </button>
  );
}
